import { Start } from "@mui/icons-material";
import "./SuccessStoriesCarousel.css";
import { SuccessStory } from "./SuccessStoriesSpeakForThemselves";
import SuccessStoryCard, { StartOwnSuccessStory } from "./SuccessStoryCard";

const carouselForDesktop = (successStories: SuccessStory[]) => {
  if (successStories.length === 0) {
    return <p>No success stories available at the moment.</p>;
  }

  // Build slides: pair stories two by two
  const slides: JSX.Element[] = [];
  for (let i = 0; i < successStories.length - 1; i += 2) {
    const firstStory = successStories[i];
    const secondStory = successStories[i + 1];

    slides.push(
      <div className={`carousel-item ${i === 0 ? "active" : ""}`} key={i}>
        <div className="row">
          <div className="col-12 col-md-6 mb-3">
            <SuccessStoryCard story={firstStory} />
          </div>
          <div className="col-12 col-md-6 mb-3">
            {secondStory ? (
              <SuccessStoryCard story={secondStory} />
            ) : (
              <StartOwnSuccessStory />
            )}
          </div>
        </div>
      </div>,
    );
  }

  // Always add the CTA card paired with the last story (odd count guarantee)
  const lastIndex = successStories.length - 1;
  if (successStories.length % 2 === 1) {
    slides.push(
      <div className="carousel-item" key="cta-slide">
        <div className="row">
          <div className="col-12 col-md-6 mb-3">
            <SuccessStoryCard story={successStories[lastIndex]} />
          </div>
          <div className="col-12 col-md-6 mb-3">
            <StartOwnSuccessStory />
          </div>
        </div>
      </div>,
    );
  }

  return (
    <div
      id="carouselExampleControlsDesktop"
      className="carousel slide success-stories-carousel"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">{slides}</div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleControlsDesktop"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleControlsDesktop"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default carouselForDesktop;
